import React from "react";
import PropTypes from "prop-types";

const EventSearchTeaser = ({ event }) => {
  let eventLabel = null;
  let eventImage = event.image;

  if (event.isMust) {
    eventLabel = "Must";
  } else if (event.isSelect) {
    eventLabel = "Bruzz select";
  }

  if (eventImage === null || eventImage === "") {
    const { agendaFallbackImage } = window.drupalSettings;
    eventImage = agendaFallbackImage;
  }

  return (
    <div
      className="event-search-teaser card is-list is-highlight-md has-label is-image-fixed-height"
      key={event.key}
    >
      <a href={event.url} className="card__image">
        <img
          className="card__image-img lozad"
          src={eventImage}
          alt={event.title}
        />
        <div className="card-text-overlay">
          <div className="card-text-overlay__bg" />
          <div className="card-text-overlay__overlay" />
          <div className="card-text-overlay__text">{event.date}</div>
        </div>
      </a>
      <div className="card__content">
        {eventLabel && <span className="card__label label">{eventLabel}</span>}
        {event.date && (
          <div className="card-text-overlay-mobile">{event.date}</div>
        )}
        <h3 className="card__title">
          <a href={event.url} className="card__title-link">
            {event.title}
          </a>
        </h3>
        <div className="card__meta">
          {event.category && (
            <div className="card__main main-tag">{event.category}</div>
          )}
          {event.location && (
            <span className="card__location">
              <svg viewBox="0 0 16 19">
                <use xlinkHref="#location" />
              </svg>
              {event.location}
            </span>
          )}
          {event.languages && event.languages.length > 0 && (
            <div className="card__languages">
              <svg viewBox="0 0 16 16">
                <use xlinkHref="#globe" />
              </svg>

              <span className="card__languages-title">Ook in:</span>
              {event.languages.map((eventLanguage) => {
                if (event.languageUrls && event.languageUrls[eventLanguage]) {
                  return (
                    <a
                      href={event.languageUrls[eventLanguage]}
                      className="card__languages-lang"
                      key={event.languageUrls[eventLanguage]}
                    >
                      {eventLanguage}
                    </a>
                  );
                }

                return (
                  <span className="card__languages-lang">{eventLanguage}</span>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

EventSearchTeaser.propTypes = {
  event: PropTypes.objectOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      location: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      isMust: PropTypes.bool.isRequired,
      isSelect: PropTypes.bool.isRequired,
      languages: PropTypes.arrayOf(PropTypes.shape),
      key: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default EventSearchTeaser;
